module.exports = {"id":"176376","name":"Ignacio Piatti","rating":"80","photo":"./data/images/photos/0/176376.png","club":{"name":"Impact Montréal","logo":"./data/images/clubs/ImpactMontreal.png"},"positions":["AG","MG","ATT"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IgnacioPiatti0.json
// module id = 1781
// module chunks = 0